/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum CreditPlanFailureReason {
  GENERAL = 'General',
  NO_CREDIT_REQUIREMENTS = 'NoCreditRequirements',
  NO_PROGRAMS_FOUND = 'NoProgramsFound',
  NO_PROGRAMS_PICKED_FOR_PLAN = 'NoProgramsPickedForPlan',
  UNABLE_TO_START_PLAN_GENERATION = 'UnableToStartPlanGeneration',
  UNABLE_TO_RETRIEVE_PLAN = 'UnableToRetrievePlan'
}
